// extracted by mini-css-extract-plugin
export default {"block_left_03":"index_block_left_03_XqRXU","dl_list_01":"index_dl_list_01_wBdgr","text":"index_text_5f9ch","links":"index_links_WjTBQ"};